import { Language } from "../constants";
import { useA11y } from "../i18n";

interface PartnerLogosProps {
  lang: Language;
  className?: string;
}

export function PartnerLogos({ lang, className = "" }: PartnerLogosProps) {
  const A11y = useA11y(lang);

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 ${className}`}>
      <img
        src="/logos/heriforge-logo-black.svg"
        alt="HERIFORGE"
        className="w-[84%] max-w-[300px] sm:w-[46%] sm:max-w-[210px] h-auto"
      />
      <div className="w-16 h-px sm:w-px sm:h-auto sm:self-stretch bg-stone-300" aria-hidden="true" />
      <img
        src={`/logos/${lang}_FundedbytheEU_RGB_POS.svg`}
        alt={A11y.euFundingAlt}
        className="w-[60%] max-w-[210px] sm:w-[30%] sm:max-w-[135px] h-auto"
      />
    </div>
  );
}
